<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-skeleton-loader class="mx-auto" type="heading" />
      </v-col>
    </v-row>
    <v-row class="mr-2 ml-2">
      <v-col cols="12">
        <v-skeleton-loader class="mx-auto" type="image" />
      </v-col>
    </v-row>
    <v-row class="mr-2 ml-2">
      <v-col cols="12">
        <v-skeleton-loader class="mx-auto" type="image" />
      </v-col>
    </v-row>
    <v-row class="mr-2 ml-2">
      <v-col cols="12">
        <v-skeleton-loader class="mx-auto" type="image" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "SkeletonCadastroFila",
};
</script>